module.exports = __webpack_public_path__ + "static/media/dem_fir_gas_vap.a8819a84.png";